import api from './api';

export const recommendationService = {
    async checkEligibility(levelId) {
        try {
            const response = await api.get('/recommendation.php', {
                params: { action: 'check_eligibility', level_id: levelId }
            });
            return response.data;
        } catch (error) {
            console.error('API Error (Recommendation eligibility):', error);
            throw error;
        }
    },

    async generate(data) {
        try {
            const response = await api.post('/recommendation.php?action=generate', data);
            return response.data;
        } catch (error) {
            console.error('API Error (Recommendation generate):', error);
            throw error;
        }
    },

    getViewUrl(letterId) {
        return `${api.defaults.baseURL}/recommendation.php?action=view&letter_id=${letterId}`;
    },

    async getHistory(levelId) {
        try {
            const params = { action: 'history' };
            if (levelId) params.level_id = levelId;
            const response = await api.get('/recommendation.php', { params });
            return response.data || [];
        } catch (error) {
            console.error('API Error (Recommendation history):', error);
            return [];
        }
    }
};

export default recommendationService;
